module.exports = __webpack_public_path__ + "img/hr-brown-asterisk-01.89331ef9.png";